import useNetworkRequest from "./useNetworkRequest";
import { EddStatusResponse } from "../types/edd.types";

interface UseEddStatusParams {
  dependencyCondition?: boolean;
  dependencyList?: any[];
}

interface UseEddStatusReturn {
  data: EddStatusResponse | null;
  isFetching: boolean;
  isRevalidating: boolean;
  errors: any;
  refresh: () => void;
}

const useEddStatus = ({
  dependencyCondition = true,
  dependencyList = []
}: UseEddStatusParams = {}): UseEddStatusReturn => {
  return useNetworkRequest({
    networkCallParams: {
      url: "v2/limits/edd/status",
      method: "GET",
      service: "wallet"
    },
    dependencyCondition,
    dependencyList
  }) as UseEddStatusReturn;
};

export default useEddStatus;
